import LongText from 'components/atoms/long_text';
import SelectButton from 'components/atoms/select_button';
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import { FinishedData } from 'store/modules/management_store/types';

interface DataTableItem {
  id: number;
  edict: string;
  object: string;
  public_body: string;
  city: string;
  state: string;
  bidding: FinishedData;
  isManaged: boolean;
  dataValidadeTimestamp: string;
  task_amount: number;
  currentCompany: number;
  isChecked: boolean;
}

const EDITAL_GROW = 0;
const ORGAO_GROW = 2;
const OBJETO_GROW = 3;
const PRAZO_GROW = 1;
const TAREFAS_GROW = 0;
const BUTTON_GROW = 0;
const SELECT_GROW = 0;

export const datatableData = (
  managedList: Array<FinishedData>,
  currentCompany: number,
  selectedFinished: Array<number>,
): Array<DataTableItem> => {
  return managedList.map((bidding) => {
    const isChecked = selectedFinished.includes(bidding.id);
    return {
      id: bidding.id,
      edict: bidding.edital,
      object: bidding.objeto,
      public_body: bidding.public_body?.nome,
      city: bidding.orgao_cidade,
      state: bidding.orgao_estado,
      bidding,
      isManaged: bidding.managed,
      dataValidadeTimestamp: moment(bidding.data_validade).format('X'),
      task_amount: bidding.total_managed_opened_tasks || 0,
      currentCompany,
      isChecked,
    };
  });
};

export const datatableColumns = (toggleSelected: (id: number) => void) => {
  return [
    {
      name: '',
      width: '80px',
      sortable: true,
      selector: (data: DataTableItem) => data.id,
      center: true,
      grow: SELECT_GROW,
      cell: (data: DataTableItem) => (
        <div
          className="databalloon"
          aria-label={data.isChecked ? 'Remover da seleção' : 'Selecionar licitação'}
          data-balloon-pos="right"
        >
          <SelectButton
            id={data.id}
            isChecked={data.isChecked}
            toggleSelected={toggleSelected}
            text=""
          />
        </div>
      ),
    },
    {
      name: 'Edital',
      width: '110px',
      sortable: true,
      selector: (data: DataTableItem) => data.edict,
      center: true,
      grow: EDITAL_GROW,
      cell: (data: DataTableItem) => (
        <div className="text-center">
          <p className="m-0 p-1">{data.edict}</p>
        </div>
      ),
    },
    {
      name: 'Órgão',
      sortable: true,
      selector: (data: DataTableItem) => data.public_body,
      wrap: true,
      grow: ORGAO_GROW,
      cell: (data: DataTableItem) => (
        <div>
          <div className="m-0 font-weight-bold">{data.public_body}</div>
          <div>
            {data.city}/{data.state}
          </div>
        </div>
      ),
    },
    {
      name: 'Objeto',
      id: 'objeto',
      sortable: true,
      selector: (data: DataTableItem) => data.object,
      wrap: true,
      ignoreRowClick: true,
      grow: OBJETO_GROW,
      cell: (data: DataTableItem) => <LongText fullText={data.object} />,
    },
    {
      name: 'Prazo',
      sortable: true,
      wrap: true,
      grow: PRAZO_GROW,
      selector: (data: DataTableItem) => data.dataValidadeTimestamp,
      cell: (data: DataTableItem) => (
        <div>
          {data.bidding.datahora_visita ? (
            <div>
              <p className="m-0">
                <b>Visita:</b> {moment(data.bidding.datahora_visita).format('DD/MM/YYYY HH:mm')}
              </p>
            </div>
          ) : (
            ''
          )}
          {data.bidding.datahora_documento ? (
            <div>
              <p className="m-0">
                <b>Documento:</b>{' '}
                {moment(data.bidding.datahora_documento).format('DD/MM/YYYY HH:mm')}
              </p>
            </div>
          ) : (
            ''
          )}
          {data.bidding.datahora_abertura ? (
            <div>
              <p className="m-0">
                <b>Abertura:</b> {moment(data.bidding.datahora_abertura).format('DD/MM/YYYY HH:mm')}
              </p>
            </div>
          ) : (
            ''
          )}
          {data.bidding.datahora_prazo ? (
            <div>
              <p className="m-0">
                <b>Prazo:</b> {moment(data.bidding.datahora_prazo).format('DD/MM/YYYY HH:mm')}
              </p>
            </div>
          ) : (
            ''
          )}
        </div>
      ),
    },
    {
      name: 'Tarefas em aberto',
      width: '120px',
      center: true,
      sortable: true,
      selector: (data: DataTableItem) => data.task_amount,
      grow: TAREFAS_GROW,
      cell: (data: DataTableItem) => (
        <span className="badge badge-secondary" style={{ fontSize: '0.85rem', padding: '0.30rem' }}>
          {data.task_amount}
        </span>
      ),
    },
    {
      name: '',
      width: '180px',
      center: true,
      allowOverflow: true,
      grow: BUTTON_GROW,
      cell: (data: DataTableItem) => (
        <Link
          className="btn btn-sm btn-primary tour-access-btn"
          to={`/minhas_licitacoes/management/${data.bidding.id}/${data.currentCompany}`}
        >
          Acessar a licitação
        </Link>
      ),
    },
  ];
};
